import { connect } from 'react-redux';
import ShopsTable from '../components/ShopsTable';
import { getDisabledShops } from '../reducers';

const mapStateToProps = state => ({
  shops: getDisabledShops(state),
  showLoading: state.admin.isFetching,
});

export default connect(mapStateToProps)(ShopsTable);
